import { useMutation } from 'react-query'
import { TAddRecordPayload } from '../types/feed'
import useUserId from './useUserId'
import { useQueryClient } from 'react-query'
import { coreAPI } from '../coreApi'

const useSubmitEvaluation = () => {
  const queryClient = useQueryClient()
  const userId = useUserId()
  const submit = useMutation(
    (mutationPayload: TAddRecordPayload) =>
      coreAPI.post(`/v1/management/users/${userId}/evaluations`, mutationPayload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('userRecords')
        queryClient.invalidateQueries('userDetail')
      },
    },
  )

  return submit
}

export default useSubmitEvaluation
